import template from './navShoppingCart.html';

class NavShoppingCartController {
    /*@ngInject*/ 
    constructor() {
    }

    $onInit() {
    }
}

export default {
    template: template,
    bindings: {
        cart: '<',
        paymentInfo: '<'
    },
    controller: NavShoppingCartController
};